<template>
  <div>
    <div v-if="userDetails.wonPrizes.length === 0">
      <div class="profile__prizes_won">
        <div class="col-12 profile_prizes_won_header">
          {{ getTranslations.home_profile_profile_prizes_won }}
        </div>
        <div class="col-12 profile_prizes_won_info_msg"
             v-if="hasFbShare() && eligibleForReward">
          {{ getTranslations.home_profile_profile_share_victory }} {{ getFbPoints }} {{ getTranslations.home_profile_profile_share_bonus_points }}
        </div>
        <ul class="prizes_won_list prizes_won_list_empty">
          <li>
            {{ getTranslations.home_profile_profile_no_prizes }}
          </li>
        </ul>
      </div>
    </div>
    <div v-else>
      <div class="profile__prizes_won">
        <div class="col-12 profile_prizes_won_header">
          {{ getTranslations.home_profile_profile_prizes_won }}
        </div>
        <div class="col-12 profile_prizes_won_info_msg"
             v-if="hasFbShare() && eligibleForReward">
          {{ getTranslations.home_profile_profile_share_victory }} {{ getFbPoints }} {{ getTranslations.home_profile_profile_share_bonus_points }}
        </div>
        <ul class="prizes_won_list">
          <virtual-list :size="orderedPrizes.length"
                        :remain="10"
                        :pagemode="true">
            <li v-for="(prize, index) in orderedPrizes"
                :key="index">
              <div class="row">
                <div class="col-3">
                  <img class="prizes_won_list_image"
                       height="66"
                       width="60"
                       :src="prize.url || 'static/images/icon-data-no-shadow.svg'">
                </div>
                <div class="col-6 profile_prize_cell">
                <span class="profile_prize_description">
                  {{ prize.name }}
                </span>
                  <span class="profile_prize_description_date">
                  {{ prize.awardDate | getMoment }}
                </span>
                </div>
                <div class="col-3 profile_prize_cell">
                  <a class="fb_btn btn--icon" v-if="hasFbShare()" style="cursor:pointer" @click.prevent="shareVictory(prize.awardDate)">
                    <i class="icon-facebook"></i>
                    <span>{{ getTranslations.home_store_share }}</span>
                  </a>
                </div>
              </div>
              <span class="custom_fb_error_msg" v-if="hasFbShare() && fb_error_share">
                {{ getTranslations.home_store_this_fb }}
              </span>
            </li>
          </virtual-list>
        </ul>
      </div>
    </div>
  </div>
</template>


<script>
  /* eslint no-param-reassign: ["error", { "props": false }], no-console: "off" */
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import 'owl.carousel';
import Vue from 'vue';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import ResumeGame from '@/components/home/modals/ResumeGame';
import ZeroBalance from '@/components/home/modals/ZeroBalance';
import ResubscribeGameSms from '@/components/home/modals/ResubscribeGameSms';
import ResubscribeGame from '@/components/home/modals/ResubscribeGame';
import { updateProgressBarGamesWon, updateProgressBarAnswersPercent } from '@/common/jQuery';
import RoundUpMixin from '@/common/mixins/roundUp';
import FacebookMixin from '@/common/mixins/facebookIntegration';
import virtualList from 'vue-virtual-scroll-list';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  mixins: [NumbersFormattingMixin, RoundUpMixin, FacebookMixin],
  components: { VirtualList: virtualList },
  data() {
    return {
      action: 'SHARE_VICTORY',
      fb_error: false,
      redirectUrl: '',
      showedModal: false,
      currentPrizeId: '',
      eligibleForReward: false,
      fb_error_share: false,
    };
  },
  mounted() {
    this.renderProgressBar();
  },
  updated() {
    this.renderProgressBar();
  },
  created() {
    if (this.hasFbShare()) {
      this.isEligibleForSharePoints({ action: this.action }).then((response) => {
        this.eligibleForReward = response.data;
      });
    }
    this.redirectUrl = `${window.location.href}/${this.getLocale || localStorage.getItem('locale')}/`;
    this.fetchData();
    this.forceFbToScrapNewMetadata(this.redirectUrl, () => {
      // eslint-disable-next-line
      console.log('successful scrapping!');
    });
  },
  methods: {
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapActions('profile', [
      'giveContent',
      'isEligibleForSharePoints',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          if (!this.showedModal) {
            console.log("----------------------- Correct DefaultContentProfile For  Store hideModal");
            this.showedModal = true;
            this.storeModalForHomePage(null);
          } else {
            this.storeModalForHomePage(null);
          }
        });
      });
      /* eslint-enable */
    },
    playMethod() {
      console.log('showing resume game pop up in DefaultContentProfile Page...');
      this.checkIfGameToResumeExists().then(() => {
        console.log('this.gameInProgress:', this.gameInProgress);
        if (this.gameInProgress) {
          console.log('showing resume game pop up...');
          this.storeModalForHomePage(ResumeGame);
        } else if (this.userDetails.availableGames === 0 && !this.userDetails.subscribed) {
          if (this.subAndUnsubViaSMS) {
            if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
              this.storeModalForHomePage(ResubscribeGameSms);
            } else {
              this.storeModalForHomePage(ResubscribeGame);
            }
          } else {
            this.storeModalForHomePage(ResubscribeGame);
          }
        } else if (this.userDetails.availableGames === 0 && this.userDetails.subscribed) {
          this.storeModalForHomePage(ZeroBalance);
        } else {
          this.$router.push('/searchingOpponent');
          this.storeModalForHomePage(null);
        }
        this.showModal();
      }).catch(error => console.error(error));
    },
    fetchData() {
      /* eslint-disable */
      this.$nextTick(() => {
        $('.theme-carousel').owlCarousel({
          loop: false,
          responsiveClass: true,
          dots: true,
          autoplay: false,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
          navContainer: '.carousel__nav',
          dotsContainer: '.carousel__dots',
          navText: ['<i   class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'],
          responsive: {
            0: {
              items: 4,
              nav: true,
              onInitialized: function() {
                $(".icon-arrow-left").addClass("deactivated");
              },
              onTranslated: function(event){
                $('.icon-arrow-right').removeClass('deactivated');
                $('.icon-arrow-left').removeClass('deactivated');
                if (event.item.index == 0){
                  $(".icon-arrow-left").addClass("deactivated");
                } else {
                  $(".icon-arrow-left").show();
                }
                if (event.item.index == (event.item.count - 4)){
                  $(".icon-arrow-right").addClass("deactivated");
                }
                else {
                  $(".icon-arrow-right").show();
                }
              }
            },
          },
        })
      });
      /* eslint-enable */
    },
    renderProgressBar() {
      // console.clear();
      this.$nextTick(() => {
        updateProgressBarGamesWon(this.gamesWonPercentRatio);
        updateProgressBarAnswersPercent(this.correctAnswersPercentRatio);
      });
    },
    hasFbShare() {
      return this.userDetails.facebookId && this.facebookFunctionality;
    },
    assignPoints() {
      this.giveContent({ action: this.action, points: this.getFbPoints, uniqueId: this.currentPrizeId });
    },
    showError() {
      this.fb_error = true;
    },
    showErrorShare() {
      this.fb_error_share = true;
    },
    shareVictory(prizeId) {
      this.currentPrizeId = prizeId;
      this.fb_error = false;
      this.share(
        this.userDetails.facebookId,
        this.userDetails.id,
        this.assignPoints,
        this.showErrorShare,
      );
    },
  },
  computed: {
    orderedPrizes() {
      return this.userDetails.wonPrizes.slice(0).sort((item1, item2) => item2.awardDate - item1.awardDate);
    },
    getFbPoints() {
      const userPoints = (this.userDetails.facebookId ? this.userDetails.totalPointsEarned : this.userDetails.totalPointsEarned + this.connectionPoints);
      return this.roundUpNumber(Math.floor(userPoints * 0.05));
    },
    ...mapState('game', [
      'gameInProgress',
    ]),
    ...mapState('common', [
      'userDetails',
      'facebookFunctionality',
      'reoptinAndOptoutConfig',
      'subAndUnsubViaSMS',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    gamesWonPercentRatio() {
      return Math.round((this.userDetails.gamesWon / this.userDetails.gamesPlayed) * 100);
    },
    correctAnswersPercentRatio() {
      return Math.round((this.userDetails.correctAnswersGiven / this.userDetails.answersGiven) * 100);
    },
  },
  filters: {
    getMoment(date) {
      return moment(date).format('DD/MM/YYYY'); // .fromNow();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/DefaultContentProfile.vue